module.exports = __webpack_public_path__ + "img/0-md.8dae2c25.jpg";